export const ONBOARDING_FLAGS = {
  HAS_COMPLETED_CURRENT_ONBOARDING_VERSION: 'latestScalerOnboardingViewed',
  HAS_SEEN_CURRENT_PRICING_PAGE_VERSION: 'latestScalerPricingPageViewed',
} as const;

export type OnboardingFlag =
  (typeof ONBOARDING_FLAGS)[keyof typeof ONBOARDING_FLAGS];

export const CURRENT_ONBOARDING_VERSION = 1;
export const CURRENT_PRICING_PAGE_VERSION = 1;
